import { forgotPassword as _forgotPassword } from '@griply/services';
import { AuthFlow } from '@griply/types';
import { httpsCallable } from 'firebase/functions';

import { getFunctions, handleAuthError } from './helpers';

export const forgotPassword = async (email: string) => {
  try {
    await _forgotPassword({ functions: getFunctions(), httpsCallable, email });
  } catch (e) {
    throw handleAuthError(e, AuthFlow.ForgotPassword);
  }
};
